module.exports = __webpack_public_path__ + "img/4-classes-table.4346baf6.svg";